import Dropdown from 'react-bootstrap/Dropdown';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../types/hooks';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { language$, logOut } from '../../store/slices/user';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../routes';
// import UserAvatar from '../Elements/UserAvatar';
import { FaCogs, FaLocationArrow, FaMap, FaSignOutAlt, FaUser } from 'react-icons/fa';
import { colors } from '../../utils/colors';
import { MdOnlinePrediction } from 'react-icons/md';
import { logAction } from '../../store/actions/logActions';
import Image from 'react-bootstrap/Image';
import { LogoMiniWhite } from '@minifinder/resources/images';

const HunterHeader = () => {
    const { t } = useTranslation();
    const d = useAppDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const socketsConnected = useAppSelector((s) => s.settings.socketsConnected);

    const user = useAppSelector((s) => s.user.data);
    const deviceInfo = useAppSelector((s) => s.hunter.deviceInfo);
    const { isCreating } = useAppSelector((s) => s.tag);
    const language = useAppSelector(language$);

    const [width, setWidth] = useState(window.innerWidth);

    const isDesktop = width > 991;

    const handleResize = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const showSecondaryBar = useMemo(() => {
        if (isDesktop) return true;
        return ![APP_ROUTES.account, APP_ROUTES.map, APP_ROUTES.home].includes(pathname);
    }, [pathname, isDesktop, isCreating]);

    const onLogout = useCallback(async () => {
        await d(logOut());
        navigate(APP_ROUTES.login);
        d(logAction({ activityId: 65 }));
    }, []);

    const toAccount = () => {
        navigate(APP_ROUTES.account);
        d(logAction({ activityId: 20 }));
    };

    const LeftPart = useMemo(() => {
        if (pathname === APP_ROUTES.appSettings) {
            return (
                <div className="header-left-part">
                    <span className="header-left-title">{t('appSettings.title')}</span>
                </div>
            );
        }
        // if (pathname === APP_ROUTES.home) {
        //     return (
        //         <div className="header-left-part">
        //             <span className="header-left-title">{t('web.home.map')}</span>
        //         </div>
        //     );
        // }
        if (pathname === APP_ROUTES.devices) {
            return (
                <div className="header-left-part">
                    <span className="header-left-title">{t('web.home.devices')}</span>
                </div>
            );
        }

        if (pathname === APP_ROUTES.changeLanguage) {
            return (
                <div className="header-left-part">
                    <span className="header-left-title">{t(`languageSettings.title`)}</span>
                </div>
            );
        }

        if (pathname === APP_ROUTES.account) {
            return (
                <div className="header-left-part">
                    <span className="header-left-title">{t('account.account')}</span>
                </div>
            );
        }

        return <div />;
    }, [pathname, language, deviceInfo, user]);

    const toAppSettings = useCallback(() => {
        navigate(APP_ROUTES.appSettings);
    }, []);

    return (
        <>
            <Navbar expand="lg" bg="dark" data-bs-theme="dark" className="d-lg-none d-block">
                <div className="sockets-icon-wrapper">
                    <MdOnlinePrediction color={socketsConnected ? colors.white : colors.red} />
                </div>
                <Container fluid>
                    <Navbar.Brand className="d-flex">
                        <div className="avatar-wrapper" tabIndex={-1} onKeyDown={() => null} role="button">
                            <Image style={{ width: '100%', height: '100%' }} src={LogoMiniWhite} />
                        </div>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between">
                        <Nav className="me-auto">
                            <Nav.Link className="h-nav-link" href={APP_ROUTES.map}>
                                <FaMap color={colors.white} className="me-2" /> {t('web.sidebar.map')}
                            </Nav.Link>
                            <Nav.Link className="h-nav-link" href={APP_ROUTES.devices}>
                                <FaLocationArrow color={colors.white} className="me-2" /> {t('web.sidebar.devices')}
                            </Nav.Link>
                        </Nav>

                        <Nav className="mt-3">
                            <Nav.Link className="h-nav-link" href={APP_ROUTES.account}>
                                <FaUser color={colors.white} className="me-2" /> {t('account.account')}
                            </Nav.Link>

                            <Nav.Link className="h-nav-link" href={APP_ROUTES.appSettings}>
                                <FaCogs color={colors.white} className="me-2" /> {t('appSettings.title')}
                            </Nav.Link>
                            <Nav.Link className="h-nav-link" onClick={onLogout}>
                                <FaSignOutAlt color={colors.white} className="me-2" /> {t('button.logout')}
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {showSecondaryBar && (
                <div className="h-header">
                    {LeftPart}
                    <div className="right-part">
                        <Dropdown className="ms-auto d-none d-lg-block">
                            <Dropdown.Toggle variant="light" id="dropdown-basic" className="secondary-bar-toggle">
                                {user?.email}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={toAccount}>{t('account.account')}</Dropdown.Item>
                                <Dropdown.Item onClick={toAppSettings}>{t('appSettings.title')}</Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item onClick={onLogout}>{t('button.logout')}</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            )}
        </>
    );
};

export default React.memo(HunterHeader);
